// const apiURL = "https://cryptotradeapi.solvyxx.com";
// const apiURL = "https://api-v2.versetrade.tech";
const apiURL = "https://api.versetrade.tech";
// const apiURL = "http://localhost:9000";
const API_BASE_URL = `${apiURL}/api/v1`;

export { apiURL, API_BASE_URL };
